export const treatmentReducers = {
    saveTreatment(state, action) {
        state.isLoading = false;
        state.createLead = {
            ...state.createLead,
            lead_treatment: action.payload
        };
    },
    updateLeadTreatment(state, action) {
        state.followLead = {
            ...state.followLead,
            lead_treatments: action?.payload
        };
        state.newLeadDetail = {
            ...state.newLeadDetail,
            lead_treatment: {
                treatment: action?.payload?.[0]?.treatment,
                custom_price: action?.payload?.[0]?.price,
                teethAmount: action?.payload?.[0]?.leadtreatment_specification?.teeth_count
            }
        }
    },
    startLoadingDepositPending(state, action) {
        state.isLoadingDepositPending = action.payload;
    },
    setCurrentTreatmentData(state, action) {
        state.currentTreatmentData = action.payload;
    },
    setAttendedActiveTab(state, action) {
        state.attendedActiveTab = action.payload;
    },
    setDepositStatus(state, action) {
        state.treatmentDepositStatus = action.payload;
    },
    setTreatmentLoading(state, action) {
        state.treatmentLoading = action.payload;
    },
};
